module.exports = __webpack_public_path__ + "img/masvalor2.b175bde4.svg";